export enum ConsultationRequestOrderStatus {
  Active = 'Active',
  Canceled = 'Canceled',
}
